import { IResourceComponentsProps, useExport } from '@pankod/refine-core'

import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  Menu,
  Divider,
  Input,
  Button,
  useTable,
  Form,
} from '@pankod/refine-antd'
// import { useTable } from '@pankod/refine-core'

import { ICompetency, ICompetencyType, ITNTaxonomy } from 'interfaces'
import { CreateCompetency } from './create'
import { EditCompetency } from './edit'
import { useState } from 'react'
import { exportToExcel } from 'exportToExcel'
const { PlusOutlined } = Icons

export const CompetenciesList: React.FC<IResourceComponentsProps> = () => {
  const [pagination, setHasPagination] = useState<any>(true)
  const { tableProps, searchFormProps, sorter, tableQueryResult, setFilters } = useTable<ICompetency>({
    hasPagination: pagination,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    metaData: {
      fields: [
        'id',
        'competency_type_id',
        { competency_type: ['name'] },
        'name',
        'created_at',
        { questions: ['id'] },
        { strands: ['id'] },
        { teacher_levels: ['id'] },
        { tn_taxonomys: ['id'] },
      ],
    },
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    onSearch: (values: any) => {
      return [
        {
          field: 'name',
          operator: 'contains',
          value: `%${values.title}%`,
        },
      ]
    },
  })
  const { tableQueryResult: exportDta } = useTable<ICompetency>({
    hasPagination: false,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    metaData: {
      fields: [
        'id',
        'competency_type_id',
        { competency_type: ['name'] },
        'name',
        'created_at',
        { questions: ['id'] },
        { strands: ['id'] },
        { teacher_levels: ['id'] },
        { tn_taxonomys: ['id'] },
      ],
    },
    permanentFilter:[
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ]
  })
  const { formProps, modalProps, show } = useModalForm({
    resource: 'competencies',
    action: 'create',
  })
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
  } = useModalForm({
    resource: 'competencies',
    action: 'edit',
    warnWhenUnsavedChanges: true,
    metaData: {
      fields: ['id', 'competency_type_id', { competency_type: ['name'] }, 'name', 'created_at'],
    },
  })
  console.log({ exportDta })
  const triggerExport = () => {
    // setHasPagination(false)
    let data: object[] = []
    if (exportDta !== undefined) {
      exportDta?.data?.data?.forEach((item: ICompetency) => {
        data?.push({
          id: item?.id,
          name: item?.name,
          competency_type: item?.competency_type?.name,
          created_at: item?.created_at,
        })
      })
    }
    exportToExcel(data, `Competencies_${Math.round(new Date().getTime() / 1000)}.xlsx`)
  }
  // const { triggerExport, isLoading } = useExport<ICompetency>()

  const hideDeleteButton = (record: ICompetency): boolean => {
    const { questions: q, teacher_levels: tl, strands: s, tn_taxonomys: tnt } = record
    if (q !== undefined && tl !== undefined && s !== undefined && tnt !== undefined) {
      const shouldHide = q.length > 0 || tl.length > 0 || s.length > 0 || tnt.length > 0
      return shouldHide
    }
    return false
  }

  return (
    <List
      pageHeaderProps={{
        extra: [
          //  <ExportButton onClick={triggerExport} loading={isLoading} />,
          <RefreshButton onClick={() => tableQueryResult?.refetch()} />,
          <CreateButton type="primary" icon={<PlusOutlined />} onClick={() => show()} />,
          <Button onClick={triggerExport}>Export</Button>,
        ],
      }}
    >
      <Form {...searchFormProps}>
        <Space>
          <Form.Item name="title">
            <Input
              placeholder="Search by title"
              allowClear
              onChange={e => {
                if (e.type === 'click') {
                  searchFormProps.form?.submit()
                }
              }}
            />
          </Form.Item>
          <Button icon={<Icons.SearchOutlined />} onClick={searchFormProps.form?.submit}>
            Search
          </Button>
        </Space>
      </Form>
      <Divider />
      <Table {...tableProps}>
        <Table.Column dataIndex="name" title="Name" />
        <Table.Column<ICompetency> dataIndex="competency_type_id" render={(_, record) => record?.competency_type?.name} title="Competency Type" />
        <Table.Column
          dataIndex="created_at"
          title="Created At"
          render={value => <DateField value={value} format="LLL" />}
          defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
          sorter
        />
        <Table.Column<ICompetency>
          title="Actions"
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton
                size="small"
                type="link"
                icon={null}
                recordItemId={record.id}
                onClick={() => {
                  editShow(record.id)
                }}
              />

              <DeleteButton size="small" type="link" icon={null} recordItemId={record.id} hidden={hideDeleteButton(record)} />
            </Space>
          )}
        />
      </Table>
      <CreateCompetency modalProps={modalProps} formProps={formProps} />
      <EditCompetency modalProps={editModalProps} formProps={editFormProps} />
    </List>
  )
}
